import { Box, Item } from '@factorialco/deprecated-design-system'
import { PayrollConceptOptionFragment } from 'generated/resources/graphql'
import { keyBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import {
  A3InnuvaMapping,
  A3InnuvaWizardData,
} from 'modules/payroll_integrations_a3innuva/lib/types'

import { MappingTable } from './MappingTable'
import { upsertCompensationMappings } from './helpers'

interface CompensationByLegalEntityFillerProps {
  data: A3InnuvaWizardData
  onMappingChanged: (mappings: A3InnuvaMapping[]) => void
  options: Item[]
  payrollConcepts: PayrollConceptOptionFragment[]
  loading?: boolean
  legalEntityId: string
}

export const CompensationByLegalEntityFiller = ({
  data,
  onMappingChanged,
  options,
  payrollConcepts,
  loading,
  legalEntityId,
}: CompensationByLegalEntityFillerProps) => {
  const mappings: A3InnuvaMapping[] = data.sources?.compensations?.mappings ?? []
  const mappingsById = keyBy(
    mappings.filter((mapping) => mapping?.meta?.legal_entity_id === legalEntityId),
    'factorial_id'
  )

  const setFormValues = (value: Item, payrollConcept: PayrollConceptOptionFragment) => {
    const newMappings = upsertCompensationMappings(
      mappings,
      value,
      payrollConcept.id.toString(),
      legalEntityId
    )
    onMappingChanged(newMappings)
  }

  const findSelection = (compensationId: string) => {
    const mapping = mappingsById[compensationId]
    if (!mapping) return ''
    return options.find((option) => option.value === mapping.a3innuva_id)?.label || ''
  }

  return (
    <Box
      border={{
        all: {
          color: 'grey000White',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{ all: 'abs008' }}
    >
      <MappingTable
        title={i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.mapping_table.a3innuva_fields'
        )}
        items={payrollConcepts}
        options={options}
        getItemId={(item) => item.id.toString()}
        getItemLabel={(item) => item.label}
        onSelect={(selectedItem, item) => setFormValues(selectedItem, item)}
        findSelection={(item) => {
          return findSelection(item)
        }}
        selectPlaceholder={i18n.t(
          'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.levels.default_value_placeholder'
        )}
        loading={loading}
        customBorder={{
          left: { color: 'grey000White', width: 's1', style: 'solid' },
          right: { color: 'grey000White', width: 's1', style: 'solid' },
          bottom: { color: 'grey000White', width: 's1', style: 'solid' },
        }}
      />
    </Box>
  )
}
